import React from "react";

const Muhammad = () => {
  return (
    <>
      <svg
        id="Layer_2"
        height="100%"
        viewBox="0 0 512 512"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 2"
      >
        <path
          d="m160 144-6.978-76.756a16 16 0 0 1 9.229-15.976l87.61-40.435a16 16 0 0 1 12.449-.406l86.49 33.266a16 16 0 0 1 10.2 16.263l-7 84.044v16h-192z"
          fill="#3a1e13"
        />
        <path
          d="m504 512v-33.805l-56-126.195h-384l-56 120v40z"
          fill="#cce9ea"
        />
        <path
          d="m120 496v16h264v-16c-32-40-24-144-24-144h-216s8 104-24 144z"
          fill="#354458"
        />
        <path
          d="m304 512v-24c18-24 24-96 24-96v-40h-144v40s6 72 24 96v24z"
          fill="#9fd3d3"
        />
        <path d="m200 264v88l56 48 56-48v-88z" fill="#e28140" />
        <path d="m112 416h16v96h-16z" fill="#a3d3c5" />
        <path d="m376 416h16v96h-16z" fill="#a3d3c5" />
        <path
          d="m272 512v-72h-32v72"
          fill="#231f20"
          stroke="#231f20"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <path
          d="m224 384v32a8 8 0 0 0 .411 2.53l8 24a8 8 0 0 0 7.589 5.47h32a8 8 0 0 0 7.589-5.47l8-24a8 8 0 0 0 .411-2.53v-32z"
          fill="#3b4c62"
        />
        <path
          d="m8 472v3.864c20.241-8.384 40.86-22.091 59.316-40.548 25.857-25.857 42.4-55.956 48.029-83.316h-51.345z"
          fill="#f9f2ed"
          opacity=".4"
        />
        <path d="m256 384c-24 8-32 56-32 56l-40-48v-40h16z" fill="#79b5b4" />
        <path d="m328 352v40l-40 48s-8-48-32-56l56-32z" fill="#79b5b4" />
        <path
          d="m256 280v24"
          fill="none"
          stroke="#231f20"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <path
          d="m200 323.212c52.244 18.922 94.943-7.19 112-20.387v-30.825h-112z"
          fill="#915024"
        />
        <path
          d="m330.413 260.789-45.919 39.359a16 16 0 0 1 -10.413 3.852h-36.162a16 16 0 0 1 -10.413-3.852l-45.919-39.359a16 16 0 0 1 -5.587-12.148v-176.641c0-8.837 160-8.837 160 0v176.641a16 16 0 0 1 -5.587 12.148z"
          fill="#c46f35"
        />
        <path
          d="m291.016 294.557-53.421-38.852a50.121 50.121 0 0 1 -20.607-42.389v-147.186c-23.455.989-40.988 2.945-40.988 5.87v176.641a16 16 0 0 0 5.587 12.148l40.915 35.07 5 4.289a16 16 0 0 0 10.416 3.852h36.162a16 16 0 0 0 10.412-3.851z"
          fill="#e28140"
          opacity=".5"
        />
        <path
          d="m234.343 157.657-5.656-5.657h-36.687v-16h40a8 8 0 0 1 5.657 2.343l8 8z"
          fill="#562719"
        />
        <path
          d="m277.657 157.657-11.313-11.313 8-8a8 8 0 0 1 5.656-2.344h40v16h-36.687z"
          fill="#562719"
        />
        <path d="m208 152h16v16h-16z" fill="#3a1e13" />
        <path d="m288 152h16v16h-16z" fill="#3a1e13" />
        <path
          d="m280 208h-48a8 8 0 0 1 -7.428-10.971l16-40 14.855 5.942-11.611 29.029h24.367l-11.611-29.029 14.855-5.942 16 40a8 8 0 0 1 -7.427 10.971z"
          fill="#8f4c2e"
        />
        <path
          d="m264 256h-24v-16h22.111l14.311-7.155 7.155 14.311-16 8a8 8 0 0 1 -3.577.844z"
          fill="#8f4c2e"
        />
        <path d="m176 216-24-24v-48l24 8z" fill="#a8602f" />
        <path d="m336 216 24-16v-56l-24 8z" fill="#a8602f" />
        <g fill="#562719">
          <path d="m299.563 246.656-21.985-14.656h-35.156l-21.985 14.656-8.875-13.312 24-16a8 8 0 0 1 4.438-1.344h40a8 8 0 0 1 4.438 1.344l24 16z" />
          <path d="m320 208v40l-48 40h-32l-48-40v-40h-16v40.641a16 16 0 0 0 5.587 12.148l45.919 39.359a16 16 0 0 0 10.412 3.852h36.162a16 16 0 0 0 10.413-3.852l45.919-39.359a16 16 0 0 0 5.588-12.148v-40.641z" />
        </g>
      </svg>
    </>
  );
};

export default Muhammad;
